import { CategoryTopBannerBuilderComponent } from '@tvlgiao/bc-supermarket-builder-components';
import React from 'react';
export default {
  CategoryTopBannerBuilderComponent,
  React
};